import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  signal,
  ViewContainerRef,
} from '@angular/core';
import { ClientsService } from '../../../pages/pages/clients/clients.service';
import { ToasterService } from '../../services/toaster.service';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { firstValueFrom } from 'rxjs';
import fa from '@angular/common/locales/fa';
import { haveSameIds } from '../../../../global.variable';

@Component({
  selector: 'gtapp-site-preferred-users',
  standalone: false,
  templateUrl: './site-preferred-users.component.html',
  styleUrl: './site-preferred-users.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
//  https://app.shortcut.com/sendem/story/12804/preferred-guards-list
export class SitePreferredUsersComponent implements OnDestroy {
  userData = signal<any>({});
  siteData = signal<any>({});

  @Input() set onSiteDataInput(value: any) {
    this.siteData.set(value);
    this.getAndFormatData();
  }
  @Input() set onUserDataInput(value: any) {
    this.userData.set(value);
    this.getAndFormatData();
  }

  @Input() showManageOption: boolean = true;

  listData: any = [];

  selectedSiteListData: any = [];
  siteListData: any = [];
  haveSameSiteIdList: boolean = true;

  selectedUserListData: any = [];
  haveSameUserIdList: boolean = true;

  initialDataList: any = {};

  constructor(
    private clientService: ClientsService,
    private toasterService: ToasterService,
    private cdr: ChangeDetectorRef,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
  ) {}

  ngOnDestroy() {}

  getAndFormatData() {
    let params: any = { list_data: 1 };
    if (this.siteData()?.id) params.site_id = this.siteData()?.id;
    if (this.userData()?.id) params.user_id = this.userData()?.id;
    this.clientService.sitePreferredUser({}, params).then((response: any) => {
      if (response?.status != 'success') {
        this.toasterService.setMessage({
          errorMessage: response?.message,
          successMessage: '',
        });
        return;
      }

      this.listData = response?.data || [];
      this.cdr.detectChanges();
    });
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  editField(field: string) {
    if (field == 'site') {
      this.shiftFocus('siteId');
    }

    this.inputFocused(field);
  }
  inputFocused(field: string) {
    this.siteListData = [];

    setTimeout(() => {
      if (field === 'site') {
        const siteDataList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
        this.siteListData = siteDataList?.filter(
          (site: any) =>
            !this.selectedSiteListData?.some(
              (selectedSite: any) => selectedSite?.id === site?.id,
            ),
        );
      }
    }, 200);
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    this.clientService
      .searchSites({
        search_str: searchString,
      })
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          const siteDataList = res?.data?.splice(0, 10);
          this.siteListData = siteDataList?.filter(
            (site: any) =>
              !this.selectedSiteListData?.some(
                (selectedSite: any) => selectedSite?.id === site?.id,
              ),
          );
          if (!event) {
            this.initialDataList.site = JSON.parse(
              JSON.stringify(this.siteListData),
            );
          }
        }
      });
  }
  async openTemplate(template: any) {
    if (this.siteData()?.id) {
      this.selectedUserListData = this.listData?.map((item: any) => ({
        id: item?.user_id,
        ...item,
        selected: true,
      }));
    } else {
      this.onSiteSearch();

      this.selectedSiteListData = this.listData?.map((item: any) => ({
        id: item?.site_id,
        ...item,
        selected: true,
      }));
      if (!this.selectedSiteListData?.length) {
        this.selectedSiteListData.push({});
      }
    }
    this.haveSameUserIdList = haveSameIds(
      JSON.parse(JSON.stringify(this.listData || [])),
      'user_id',
      this.selectedUserListData,
      'id',
    );

    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    const res = await firstValueFrom(dialogRef.afterClosed());
    if (res) {
      const params = {
        update_user_ids: this.haveSameUserIdList ? 0 : 1,
        update_site_ids: this.haveSameSiteIdList ? 0 : 1,
        site_id: this.siteData()?.id,
        user_id: this.userData()?.id,
      };
      const reqBody = {
        user_ids: [
          ...new Set(this.selectedUserListData?.map((user: any) => user?.id)),
        ],
        site_ids: [
          ...new Set(this.selectedSiteListData?.map((site: any) => site?.id)),
        ],
      };

      this.clientService
        .sitePreferredUser(reqBody, params)
        .then((response: any) => {
          if (response?.status != 'success') {
            this.toasterService.setMessage({
              errorMessage: response?.message,
              successMessage: '',
            });
            return;
          }
          this.getAndFormatData();
        });
    }
  }
  checkSiteSelection() {
    const selectedSites = this.selectedSiteListData?.filter(
      (site: any) => site?.id,
    );
    this.haveSameSiteIdList = haveSameIds(
      selectedSites,
      'id',
      JSON.parse(JSON.stringify(this.listData || [])),
      'site_id',
    );
  }

  onSelectUser(event: any) {
    event.selected = !event?.selected;
    if (event?.selected) {
      const selectedUserIndex = this.selectedUserListData?.findIndex(
        (user: any) => event?.id == user?.id,
      );
      if (selectedUserIndex > -1) {
        this.selectedUserListData[selectedUserIndex] = event;
      } else {
        this.selectedUserListData.push(event);
      }
      this.selectedUserListData = [...this.selectedUserListData];
    } else {
      this.selectedUserListData = this.selectedUserListData?.filter(
        (user: any) => user?.id != event?.id,
      );
    }

    this.haveSameUserIdList = haveSameIds(
      JSON.parse(JSON.stringify(this.listData || [])),
      'user_id',
      this.selectedUserListData,
      'id',
    );
  }
}
